import * as types from './types';

export const setLoading = (loading) => (dispatch) => {
  dispatch({
    type: types.SYSTEM_SET_LOADING,
    payload: loading,
  });
};
